<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import LocalizedSelect from '@/components/base/LocalizedSelect.vue';
import LocalizedInput from '@/components/LocalizedInput.vue';
import LocalizedVideo from '../base/LocalizedVideo.vue';
import StandardToggle from '../StandardToggle.vue';

import type { Locales, ProjectModuleDto, ProjectModuleVideoConfigDto } from '@/services/types/api.types';
import { useBlocksStore } from '@/stores';
import { useConfigurationStore } from '@/stores/configurations.store';

// CONST
const { t } = useI18n();
const blocksStore = useBlocksStore();
const alignmentOptions = blocksStore.getVideoAlignmentOptions();
const isProjectTOCEnabled = useConfigurationStore().isFeatureEnabled('projectTOC');

// PROPS
const props = defineProps<{
  languageEnabled: Locales[];
  editLocale: Locales;
  module: ProjectModuleDto;
}>();

const moduleConfig = props.module.config as ProjectModuleVideoConfigDto;
</script>
<template>
  <div class="module-video">
    <localized-input
      name="title"
      :label="t('global.label.title')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <standard-toggle name="config.highlight" :label="t('project-module.admin.highlight')" outlined />
    <standard-toggle
      v-if="isProjectTOCEnabled"
      name="config.includeInTableOfContents"
      :label="t('project-module.admin.includeInTableOfContents')"
      outlined
    />
    <localized-select
      name="config.videoAlignment"
      label="Position"
      :editLocale="editLocale"
      :options="alignmentOptions"
      emit-value
      outlined
      map-options
    />
    <localized-video
      name="config.video"
      :label="t('form.dialogs.module.video.url')"
      :language_enabled="props.languageEnabled"
      :caption="moduleConfig.videoCaption"
    />
  </div>
</template>
